import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Recipes from './components/Recipes';
import axios from 'axios';

function App() {
  
  const [search, setSearch] = useState("mango");
  const [recipes, setRecipes] = useState([]);

  const APP_ID = 'deb1bd5b';
  const APP_KEY = 'c3a3fab3248353672fb03ea9146bcc0e';

  useEffect(() => {
    getRecipes();
  }, []);


  const getRecipes = async () => {
    const results = await axios.get(
      `https://api.edamam.com/search?q=${search}&app_id=${APP_ID}&app_key=${APP_KEY}&from=0&to=40`
    );
    setRecipes(results.data.hits);
  }

  const onInputChange = e => {
    setSearch(e.target.value);
  }

  const onSearchClick = () => {
    getRecipes();
  }

  return (
    <div className="App">
      <Header search={search} onInputChange={onInputChange} onSearchClick={onSearchClick} />
      <div className="container">
        <Recipes recipes={recipes} />
      </div>
    </div>
  );
}

export default App;
